export default function CalendarIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4C1 2.89543 1.89543 2 3 2L4 2L4 1L6 1L6 2L10 2L10 1L12 1L12 2L13 2C14.1046 2 15 2.89543 15 4L15 12C15 13.1046 14.1046 14 13 14L3 14C1.89543 14 1 13.1046 1 12L1 4Z"
        fill="#C0C2BE"
        fillOpacity="0.5"
      />
      <path
        d="M1 4C1 2.89543 1.89543 2 3 2L4 2L4 1L6 1L6 2L10 2L10 1L12 1L12 2L13 2C14.1046 2 15 2.89543 15 4L15 6L1 6L1 4Z"
        fill="#787B74"
      />
    </svg>
  );
}
